import { NgModule } from '@angular/core';

import { ProductsListComponent } from 'ish-shared/components/product/products-list/products-list.component';
import { SharedModule } from 'ish-shared/shared.module';

import { RecentlyViewedComponent } from './shared/recently-viewed/recently-viewed.component';

@NgModule({
  imports: [ProductsListComponent, SharedModule],
  declarations: [RecentlyViewedComponent],
  exports: [SharedModule],
})
export class RecentlyModule {}
